export enum POStatus {
	Open = 1,
	Closed = 2,
	Deleted = 3,
	OverBudget = 4,
	WaitingForApproval = 5,
}

export enum POStatusDescription {
	Open = 'Open',
	Closed = 'Closed',
	Deleted = 'Deleted',
	OverBudget = 'Over Budget',
	WaitingForApproval = 'Waiting For Approval',
}
